export default __webpack_public_path__ + "static/media/numpy.8adca66f.svg";